import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext();

const LANGUAGES = [
  { code: 'pt-BR', label: 'Português', flag: '🇧🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
];

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('chatalfa-lang') || 'pt-BR';
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('chatalfa-lang', lang);
  };

  const t = useCallback((key) => {
    const langTranslations = translations[language] || translations['pt-BR'];
    return langTranslations[key] || translations['pt-BR'][key] || key;
  }, [language]);

  const currentLanguage = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  const value = {
    language,
    setLanguage,
    currentLanguage,
    languages: LANGUAGES,
    t,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export default LanguageContext;
